// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3-Q5E","prev":"prev-2axIe","next":"next-3wAdN","disabled":"disabled-zaVA1","goTo":"goTo-38QrA"};